import React from 'react';
import { HStack, VStack, Stack, Button, Text, Spacer } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import VoucherInput from './VoucherInput';
import Footer from './Footer';
import { voucherToString } from '../utils/apply-voucher';

// Definisci la funzione fuori dal componente
// export function handleOrderConfirm(paymentType) {
//   console.log('Tipo pagamento scelto:', paymentType);
//   // Qui puoi aggiungere altre logiche se necessario
// }

function Menu2OrderSummary({
  menu,
  menuUtils,
  voucher,
  setVoucher,
  isAdmin,
  isCashier,
  isAdminCashier,
  isOperator,
  isPromoter,
  isCustomer,
  // appSettings,
  clearQuantities,
  setMenu,
  rerender,
  render,
  setShowModalConfirmOrderCustomer,
  setShowModalConfirmOrderCashier,
  setPaymentType,
}) {
  return (
    <VStack>
      {!voucher && (
        <Text fontSize='3xl' fontWeight={600} color={'white'}>
          Totale {menuUtils.total(menu).toFixed(2)}€
        </Text>
      )}
      {voucher && (
        <Text fontSize='2xl' fontWeight={600} color={'white'}>
          Totale: {voucherToString(menuUtils.total(menu), voucher)}
        </Text>
      )}
      <Spacer />
      
      {isCashier && (
        <Stack align='stretch' direction={{ base: 'column', md: 'row' }}>
          <Button minW={145} as={Link} to='/dashboard' variant='secondary'>
            Dashboard
          </Button>

          <Button
            minW={145}
            isDisabled={menuUtils.total(menu) === 0}
            onClick={() => {
              setPaymentType('cash');
              setShowModalConfirmOrderCashier(true);
            }}
          >
            CONTANTI
          </Button>

          {isAdminCashier && (
            <Button
              minW={145}
              isDisabled={menuUtils.total(menu) === 0}
              onClick={() => {
                setPaymentType('free');
                setShowModalConfirmOrderCashier(true);
              }}
            >
              OMAGGIO
            </Button>
          )}

          <Button
            minW={145}
            variant='secondary'
            isDisabled={menuUtils.total(menu) === 0}
            onClick={() => {
              clearQuantities(menu);
              setMenu(menu);
              rerender(!render);
            }}
          >
            Azzera
          </Button>

          <Button
            minW={145}
            isDisabled={menuUtils.total(menu) === 0}
            onClick={() => {
              setPaymentType('card');
              setShowModalConfirmOrderCashier(true);
            }}
          >
            CARTA
          </Button>
        </Stack>
      )}
      
      {isAdmin && (
        <VStack>
          <Text my={5} color='tomato'>
            Sei loggato come admin, non puoi effettuare ordini, devi prima effettuare il logout
            dalla tua dashboard.
          </Text>
          <Button as={Link} to='/dashboard'>
            Dashboard
          </Button>
        </VStack>
      )}
      {isOperator && (
        <VStack>
          <Text my={5} color='tomato'>
            Sei loggato come operatore, non puoi effettuare ordini, devi prima effettuare il logout
            dalla tua dashboard.
          </Text>
          <Button as={Link} to='/dashboard'>
            Dashboard
          </Button>
        </VStack>
      )}
      {isPromoter && (
        <VStack>
          <Text my={5} color='tomato'>
            Sei loggato come promoter, non puoi effettuare ordini, devi prima effettuare il logout
            dalla tua dashboard.
          </Text>
          <Button as={Link} to='/dashboard'>
            Dashboard
          </Button>
        </VStack>
      )}
      {isCustomer && (
        <HStack>
          <Button
            variant='secondary'
            isDisabled={menuUtils.total(menu) === 0}
            onClick={() => {
              clearQuantities(menu);
              setMenu(menu);
              rerender(!render);
            }}
          >
            RESET
          </Button>
          <VoucherInput onVoucher={setVoucher} />
          <Button
            variant='important'
            isDisabled={menuUtils.total(menu) === 0}
            onClick={async () => {
              setShowModalConfirmOrderCustomer(true);
            }}
          >
            ACQUISTA
          </Button>
        </HStack>
      )}
      <Footer />
    </VStack>
  );
}

export default Menu2OrderSummary;
